import * as types from '../mutation-types'

const state = {
  main: {}
}

const mutations = {
  [types.SET_CARRINHO] (state, itensCarrinho) {
    state.main = itensCarrinho
  }
}

export default {
  state,
  mutations
}

